module.exports = __webpack_public_path__ + "img/search.784bb715.svg";